module.exports = __webpack_public_path__ + "img/Vertex-Degrees-vs.-Neighbors-Degrees.f5b64bf0.png";